import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { GN_CSS, GN_HTML } from './landingContent';
import AnswerBubbleDemo from '../components/demos/AnswerBubbleDemo';
import ReviewIntroDemo from '../components/demos/ReviewIntroDemo';
import GbpProfileDemo from '../components/demos/GbpProfileDemo';
import LatestBlogRow from '../components/LatestBlogRow';

// The approved GlobalNow landing (from redesign-concept/index.html), rendered as the home page.
// App.js hides the shared Navbar/Footer on "/" so this self-contained page shows on its own.
// CTAs point to the real order flow (/order). Trust-signals only (no fake reviews).
//
// GN_HTML is raw HTML (dangerouslySetInnerHTML) and contains three empty mount
// points (#widget-mount-answer / -reviews / -gbp) inside the "AI INCLUDED" section.
// We portal the three interactive "try it now" demo widgets into those nodes
// after the raw HTML is in the DOM, so they behave as real React components
// (state, loading, live API calls) inside the otherwise-static page.
//
// gnPlayInline: click-to-play handler for the below-the-fold promo videos
// (BuildFree / Included). <script> tags inside dangerouslySetInnerHTML never
// execute (browser spec), so this can't live as a raw <script> in GN_HTML —
// it's defined here as a real global, and GN_HTML's inline onclick="" attributes
// (which DO work via innerHTML) call it by name. Injects the <source> lazily so
// preload="none" truly costs zero bytes until a visitor taps play.
if (typeof window !== 'undefined' && !window.gnPlayInline) {
  window.gnPlayInline = function (wrap) {
    if (!wrap || wrap.classList.contains('iv-playing')) return;
    const video = wrap.querySelector('video');
    const src = wrap.getAttribute('data-src');
    if (video && src && !video.querySelector('source')) {
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
    }
    wrap.classList.add('iv-playing');
    if (video) {
      video.setAttribute('controls', '');
      video.play().catch(() => {});
    }
  };
}

const Home = () => {
  const containerRef = useRef(null);
  const [mounts, setMounts] = useState(null);

  // useLayoutEffect: mount points come from dangerouslySetInnerHTML, so we must query them
  // synchronously after the DOM commit and render the portals in the SAME paint (2026-09-15 fix:
  // the portals were not appearing on the live page).
  useLayoutEffect(() => {
    if (!containerRef.current) return;
    setMounts({
      answer: containerRef.current.querySelector('#widget-mount-answer'),
      reviews: containerRef.current.querySelector('#widget-mount-reviews'),
      gbp: containerRef.current.querySelector('#widget-mount-gbp'),
      blog: containerRef.current.querySelector('#widget-mount-blog'),
    });
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: GN_CSS }} />
      <div ref={containerRef} dangerouslySetInnerHTML={{ __html: GN_HTML }} />
      {mounts?.answer && ReactDOM.createPortal(<AnswerBubbleDemo />, mounts.answer)}
      {mounts?.reviews && ReactDOM.createPortal(<ReviewIntroDemo />, mounts.reviews)}
      {mounts?.gbp && ReactDOM.createPortal(<GbpProfileDemo />, mounts.gbp)}
      {mounts?.blog && ReactDOM.createPortal(<LatestBlogRow />, mounts.blog)}
    </>
  );
};

export default Home;
